export default {
    setLang({commit}, payload) {
        commit('SET_LANG', payload)
    }
};
